import React from 'react';
import classNames from 'classnames';
import { Avatar, AvatarSize } from '../../../ui';
import { parseToRGB } from '../../../common/utils/parse-color';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { getPresetColor } from './get-preset-color';
import styles from './visitor-avatar.module.scss';
const getDiameter = (size) => {
    switch (size) {
        case AvatarSize.medium:
            return 36;
        case AvatarSize.xSmall:
            return 20;
        default:
            return 28;
    }
};
const VisitorAvatar = ({ className, size = AvatarSize.medium, withBorder = false, ...props }) => {
    const { screenshotMode } = useConfiguration();
    const hexColor = screenshotMode ? getPresetColor(props.hexColor) : props.hexColor;
    const diameter = getDiameter(size);
    const hueDegree = React.useMemo(() => {
        const color = parseToRGB(hexColor);
        if (color) {
            return Math.floor(((color.r + color.g + color.b) / (765 / 360)) * 5);
        }
        else {
            return 0;
        }
    }, [hexColor]);
    return (React.createElement("div", { className: classNames(styles.avatar, className, {
            [styles.withBorder]: withBorder,
        }), style: {
            width: diameter,
            height: diameter,
        } },
        React.createElement("div", { className: styles.filter, style: {
                filter: `sepia(0.3) contrast(0.8) saturate(3) hue-rotate(${hueDegree}deg)`,
                color: hexColor,
            } },
            React.createElement(Avatar, { size: size }))));
};
export default VisitorAvatar;
//# sourceMappingURL=visitor-avatar.js.map